import { getFirebaseMessaging } from "../firebase";
import { firebaseVapidKey } from "../config/firebaseConfig";
import { getToken } from "firebase/messaging";
import { buildApiUrl } from "../helpers/base_url";

const TOKEN_STORAGE_KEY = "fcmToken";

const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem("user") || "null");
  } catch {
    return null;
  }
};

const registerTokenWithServer = async (token: string, userId?: string) => {
  try {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      console.warn("Cannot register FCM token without an access token.");
      return;
    }

    const storedUser = getStoredUser();
    const effectiveUserId =
      userId || (storedUser?.id ? String(storedUser.id) : undefined);

    if (!effectiveUserId) {
      console.warn("Missing user ID for FCM token registration.");
      return;
    }

    const userType = storedUser?.userType || "CLIENT";

    await fetch(buildApiUrl("/api/notifications/register-token"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify({
        fcmToken: token,
        userId: Number(effectiveUserId),
        userType,
        platform: "WEB_CLIENT",
      }),
    });
  } catch (error) {
    console.warn("Failed to register FCM token with server:", error);
  }
};

const getServiceWorkerRegistration = async () => {
  if (!("serviceWorker" in navigator)) return undefined;

  const existing = await navigator.serviceWorker.getRegistration(
    "/firebase-messaging-sw.js"
  );
  if (existing) return existing;

  try {
    return await navigator.serviceWorker.register(
      "/firebase-messaging-sw.js"
    );
  } catch (error) {
    console.warn("Failed to register Firebase messaging service worker:", error);
    return undefined;
  }
};

export const requestFcmToken = async (userId?: string) => {
  if (typeof window === "undefined" || !("Notification" in window)) return null;

  const storedUser = getStoredUser();
  if (!storedUser?.id && !userId) {
    return null;
  }

  const messaging = await getFirebaseMessaging();
  if (!messaging) return null;

  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    console.warn("Notification permission was not granted.");
    return null;
  }

  if (!firebaseVapidKey) {
    console.warn("Missing Firebase VAPID key.");
    return null;
  }

  const swRegistration = await getServiceWorkerRegistration();

  const token = await getToken(messaging, {
    vapidKey: firebaseVapidKey,
    serviceWorkerRegistration: swRegistration,
  }).catch((error) => {
    console.error("FCM getToken failed:", error);
    return null;
  });

  if (!token) return null;

  const storedToken = localStorage.getItem(TOKEN_STORAGE_KEY);
  if (token !== storedToken) {
    await registerTokenWithServer(token, userId);
    localStorage.setItem(TOKEN_STORAGE_KEY, token);
  }

  return token;
};

